import { createPortal } from 'react-dom';

export const MySuperBadPortal = ({ children }) => {
  if (typeof document !== 'object') return null;
  return createPortal(children, document.body);
};
